import StorageUtil from "./serviceUtils/storageUtil";

export const POLLY_VOICES = [
  { id: "yue", label: "粵語", language: "yue" },
  { id: "zh", label: "普通話", language: "zh" },
  { id: "en", label: "英語", language: "en" },
];

/** UI language → Volcengine speaker */
export const LANGUAGE_TO_SPEAKER = {
  zh: "zh_female_yingyujiaoxue_uranus_bigtts",
  // Vivi 2.0（支持粤语）
  yue: "zh_female_vv_uranus_bigtts",
  en: "zh_female_yingyujiaoxue_uranus_bigtts",
};

/** UI language → X-Api-Resource-Id（音色家族必须匹配） */
export const LANGUAGE_TO_RESOURCE_ID = {
  zh: "seed-tts-2.0",
  yue: "seed-tts-2.0",
  en: "seed-tts-2.0",
};

/** UI language → additions.explicit_dialect（Vivi 2.0 粤语等） */
export const LANGUAGE_TO_EXPLICIT_DIALECT = {
  yue: "yue",
};

const DEFAULT_VOICE_ID = "zh";
const STORAGE_KEY = "pollyVoiceLang";

export function getPollyVoices() {
  return POLLY_VOICES;
}

export function getStoredVoiceId() {
  const stored = StorageUtil.getReaderConfig(STORAGE_KEY);
  if (POLLY_VOICES.some((voice) => voice.id === stored)) {
    return stored;
  }
  return DEFAULT_VOICE_ID;
}

export function saveVoiceId(voiceId) {
  if (!POLLY_VOICES.some((voice) => voice.id === voiceId)) {
    return;
  }
  StorageUtil.setReaderConfig(STORAGE_KEY, voiceId);
}

export function resolveVoiceById(voiceId) {
  return (
    POLLY_VOICES.find((voice) => voice.id === voiceId) ||
    POLLY_VOICES.find((voice) => voice.id === DEFAULT_VOICE_ID)
  );
}

export function resolveSpeakerByLanguage(language) {
  return (
    LANGUAGE_TO_SPEAKER[language] || LANGUAGE_TO_SPEAKER[DEFAULT_VOICE_ID]
  );
}

export function resolveResourceIdByLanguage(language) {
  return (
    LANGUAGE_TO_RESOURCE_ID[language] ||
    LANGUAGE_TO_RESOURCE_ID[DEFAULT_VOICE_ID]
  );
}

export function resolveExplicitDialectByLanguage(language) {
  return LANGUAGE_TO_EXPLICIT_DIALECT[language] || undefined;
}

export function getStoredVoiceSpeed() {
  return StorageUtil.getReaderConfig("voiceSpeed") || "1";
}

/** Map UI speed (e.g. "1", "1.5") to percent rate string ("100%", "150%"). */
export function toPollyRate(speed) {
  const numeric = Number(speed);
  if (!Number.isFinite(numeric) || numeric <= 0) {
    return "100%";
  }
  return `${Math.round(numeric * 100)}%`;
}

/**
 * Map percent rate ("100%", "150%") to Volcengine speech_rate [-50, 100].
 * 100% → 0, 150% → 50, 50% → -50
 */
export function toVolcSpeechRate(rate) {
  const match = String(rate || "100%").match(/^(\d+(?:\.\d+)?)%?$/);
  const percent = match ? Number(match[1]) : 100;
  if (!Number.isFinite(percent)) {
    return 0;
  }
  return Math.max(-50, Math.min(100, Math.round(percent - 100)));
}
